export { default as ENTRY } from './entry';

export const LEGACY_PATH = '/practice/:practiceId(/**)';
export const PATH = '/practices/:practiceId(/**)';
export const BasePaths = [PATH, LEGACY_PATH];

export const pageName = 'Practice';
export const PRACTICE_GA_CATEGORY = 'PracticeProfile';
export const ROOT_KEY = 'practice';
